export type OptionDisplayType = 'swatch' | 'text' | 'dropdown';

export interface OptionDisplayDefinition {
  name: string;
  display_type?: OptionDisplayType;
}

/** @deprecated Prefer `display_type` from the product options API. */
export function isColorOptionName(optionName: string): boolean {
  const lower = optionName.toLowerCase();
  return lower === 'color' || lower === 'colour';
}

export function resolveOptionDisplayType(
  optionName: string,
  productOptions?: OptionDisplayDefinition[],
): OptionDisplayType {
  const fromApi = productOptions?.find((option) => option.name === optionName)?.display_type;
  if (fromApi) {
    return fromApi;
  }
  return isColorOptionName(optionName) ? 'swatch' : 'text';
}

export function isSwatchOption(
  option: OptionDisplayDefinition & { display_type?: OptionDisplayType },
  productOptions?: OptionDisplayDefinition[],
): boolean {
  const displayType =
    option.display_type ?? resolveOptionDisplayType(option.name, productOptions);
  return displayType === 'swatch';
}
